import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=7d392bdb&lang=pug&"
import script from "./Admin.vue?vue&type=script&lang=js&"
export * from "./Admin.vue?vue&type=script&lang=js&"
import style0 from "./Admin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d392bdb')) {
      api.createRecord('7d392bdb', component.options)
    } else {
      api.reload('7d392bdb', component.options)
    }
    module.hot.accept("./Admin.vue?vue&type=template&id=7d392bdb&lang=pug&", function () {
      api.rerender('7d392bdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Admin.vue"
export default component.exports